import { DataBean } from "../DataBean";

export class BoardColumns extends DataBean {

  public async getBoardColumnsCatalogPorPropiedades(properties: any, maxRows?: number): Promise<any> {
    return this.getCustomService(
      "ProcessFlow",
      "java.util.List_getBoardColumnsCatalogPorPropiedades_java.util.Map_Number",
      [properties, maxRows]
    );
  }

  public async deleteBoardColumns(idboardcolumns: number): Promise<any> {
    return this.getCustomService(
      "ProcessFlow",
      "boolean_deleteBoardColumns_Number",
      [idboardcolumns]
    );
  }

  public async updateBoardColumns(bean: any): Promise<any> {
    return this.getCustomService(
      "ProcessFlow",
      "com.advantage.processflow.bean.BoardColumns_updateBoardColumns_com.advantage.processflow.bean.BoardColumns",
      [
        {
          DataBeanProperties: bean,
          DataBeanName: "com.advantage.processflow.bean.BoardColumns",
        },
      ]
    );
  }
}
